import * as api from '../api/api';
import * as authApi from '../api/auth';
import * as userApi from '../api/user';
import { startLoading, stopLoading } from '../redux/slices/loadingSlice';
import { setUser } from '../redux/slices/userSlice';
import { logout as logoutUserSlice } from '../redux/slices/userSlice';
import { getUserDetails, refreshUserDetails } from './user';

export const getAuthenticatedUser = async (dispatch) => {
    try {
        const { data } = await authApi.getAuthenticatedUser();
        // console.log(data);
        
        dispatch(setUser(data.data.user));
        return data.data.user;
    } catch (error) {
        // console.error('Failed to fetch authenticated user:', error);
    }
};

export const verifyEmail = async (email, navigate, setIsLoading, setSuccessMessage, setErrorMessage) => {
    setIsLoading(true);
    try {
        const { data } = await authApi.verifyEmail(email);
        // console.log(data);

        // localStorage.setItem('sessionId', data.data.new_user.session_id);
        // localStorage.setItem('email', data.data.new_user.email);

        setSuccessMessage("Email is available!");
        setTimeout(() => setSuccessMessage(""), 3000);

        localStorage.setItem('email', email);

        setTimeout(() => navigate('/personal/signup'), 2000);
        // setTimeout(() => navigate('/otp'), 3000);
    } catch (error) {
        // console.error('Verification failed:', error);
        setErrorMessage(error?.response?.data?.message || "Failed. Please try again.");
        setTimeout(() => setErrorMessage(""), 5000);
    } finally {
        setIsLoading(false);
    }
};

export const resendEmailOtp = async (email, setIsLoading, setErrorMessage, setSuccessMessage,) => {
    setIsLoading(true);
    try {
        await authApi.resendEmailOtp(email);

        setSuccessMessage("OTP resent successfully!");
        setTimeout(() => setSuccessMessage(""), 5000);
    } catch (error) {
        setErrorMessage("Failed to resend OTP. Please try again.");
        // console.error("Failed to resend OTP:", error);
        setTimeout(() => setErrorMessage(""), 5000);
    } finally {
        setIsLoading(false);
    }
};


export const verifyEmailOtp = async (email, otpCode, navigate, dispatch, setIsLoading, setSuccessMessage, setErrorMessage) => {
    setIsLoading(true);
    try {
        await authApi.verifyEmailOtp(email, otpCode);

        dispatch(startLoading());

        getUserDetails(dispatch);
        setSuccessMessage("OTP verified successfully!");
        setTimeout(() => setSuccessMessage(""), 3000);
        setTimeout(() => navigate('/user/dashboard'), 3000);

        setTimeout(() => {
            dispatch(stopLoading());
        }, 5000);
        
    } catch (error) {
        // console.error('Verification failed:', error);
        setErrorMessage("Invalid OTP. Please try again.");
        setTimeout(() => setErrorMessage(""), 5000);
    } finally {
        setIsLoading(false); 
    }
};

export const registerUser = async (userData, dispatch) => {
    try {
        const { data } = await authApi.registerUser(userData);

        // console.log(data);
        
        localStorage.setItem('token', data.data.auth_token.plainTextToken);
        localStorage.setItem('userDetails', JSON.stringify(data.data.user));
        localStorage.setItem('authData', JSON.stringify(data.data));
        localStorage.removeItem("account_type");
        localStorage.removeItem("email");
        localStorage.removeItem("referral_code");

        refreshUserDetails(dispatch);
        
    } catch (error) {
        // console.error('Registration failed:', error);
        throw error;    
    }
};
export const loginUser = async (credentials, dispatch, navigate, setSuccessMessage, setErrorMessage, setIsLoading, toast) => {
    try {
        const { data } = await authApi.loginUser(credentials);
        // console.log(data);

        // localStorage.setItem('token', data.data.auth_token.plainTextToken);
        // localStorage.setItem('userDetails', JSON.stringify(data.data.user));
        // localStorage.setItem('authData', JSON.stringify(data.data));

        localStorage.setItem('loginEmail', JSON.stringify(credentials.email));

        // setSuccessMessage("Success! Check your email for verification pin.");
        // setTimeout(() => setSuccessMessage(""), 3000);

        // dispatch(startLoading());
        
        setSuccessMessage(data.data.message || "Success! Check your email for verification pin.");
        toast.success(data.data.message || "Success! Check your email for verification pin.");
        
        setTimeout(() => {
            navigate("/login-otp");
        }, 2000);
        
        // setTimeout(() => {
        //     dispatch(stopLoading());
        // }, 5000);
        
        setTimeout(() => setSuccessMessage(""), 3000);
        
    } catch (error) {
        // console.error("Login attempt failed:", error);
        const responseErrors = error?.response?.data?.errors;
        const fallbackMessage = error?.response?.data?.message || "Login attempt failed. Please try again.";
        
        if (responseErrors && Object.keys(responseErrors).length > 0) {
            const errorMessages = Object.values(responseErrors)
            .flat()
            .filter(Boolean); 

            setErrorMessage(errorMessages.length > 1 
            ? errorMessages[0] 
            : errorMessages.join("<br/>")
            );
        } else {
            setErrorMessage(fallbackMessage);
        }
        setTimeout(() => setErrorMessage(""), 5000);  
        // console.error("Login attempt failed:", error); 
    } finally {
        setIsLoading(false);
    }
};

export const resendLoginOtp = async (email, setIsLoading, setErrorMessage, setSuccessMessage,) => {
    setIsLoading(true);
    try {
        await authApi.resendLoginOtp(email);

        // console.log(data);
        
        setSuccessMessage("OTP resent successfully!");
        setTimeout(() => setSuccessMessage(""), 5000);
    } catch (error) {
        setErrorMessage("Failed to resend OTP. Please try again.");
        // console.error("Failed to resend OTP:", error);
        setTimeout(() => setErrorMessage(""), 5000);
    } finally {
        setIsLoading(false);
    }
};


export const verifyLoginOtp = async (credentials, navigate, setIsLoading, setSuccessMessage, setErrorMessage, dispatch) => {
    setIsLoading(true);
    try {
        const { data } = await authApi.verifyLoginOtp(credentials);
        // console.log(data);

        localStorage.setItem('token', data.data.auth_token.plainTextToken);
        localStorage.setItem('userDetails', JSON.stringify(data.data.user));
        localStorage.setItem('authData', JSON.stringify(data.data));
        localStorage.removeItem("loginEmail");
        
        dispatch(startLoading());
        
        getUserDetails(dispatch);
        setSuccessMessage("Verification successful!");
        
        setTimeout(() => navigate('/user/dashboard'), 3000);
        
        setTimeout(() => setSuccessMessage(""), 3000);

        setTimeout(() => {
            dispatch(stopLoading());
        }, 5000);
        
    } catch (error) {
        const responseErrors = error?.response?.data?.errors;
        const fallbackMessage = error?.response?.data?.message || "Invalid OTP. Please try again.";
        
        if (responseErrors && Object.keys(responseErrors).length > 0) {
            const errorMessages = Object.values(responseErrors)
            .flat()
            .filter(Boolean); 

            setErrorMessage(errorMessages.length > 1 
            ? errorMessages[0] 
            : errorMessages.join("<br/>")
            );
        } else {
            setErrorMessage(fallbackMessage);
        }

        setTimeout(() => setErrorMessage(""), 5000);  
        // console.error('Verification failed:', error);
    } finally {
        setIsLoading(false); 
    }
};


export const logout = async (token, navigate, dispatch, userTimeout = false ) => {
    dispatch(logoutUserSlice());

    const pathname = window.location.pathname;
    const redirectPath = pathname.includes('user') ? '/login' : pathname;
    
    setTimeout(() => {
        navigate(redirectPath, { state: { inactive: userTimeout ? true : false } });
    }, 1000);

    try {
        await authApi.logoutUser(token);
    } catch (error) {
        console.error('Logout attempt failed:', error);
    }
};

export const clearLocalStorage = () => {
    localStorage.clear();
};

export const passwordReset = async (email, navigate) => {
    try {
        const { data } = await authApi.passwordReset(email);
        // console.log(data);

        // localStorage.setItem('sessionId', data.data.session_id);
        localStorage.setItem('recoveryEmail', email);

        navigate('/password-otp');        
    } catch (error) {
        // console.error('Verification failed:', error);
        throw new Error("Verification failed");    
    }
}

export const resendPasswordOtp = async (email, setIsLoading, setErrorMessage, setSuccessMessage,) => {
    setIsLoading(true);
    try {
        await authApi.resendPasswordOtp(email);

        setSuccessMessage("OTP resent successfully!");
        setTimeout(() => setSuccessMessage(""), 5000);
    } catch (error) {
        setErrorMessage("Failed to resend OTP. Please try again.");
        // console.error("Failed to resend OTP:", error);
        setTimeout(() => setErrorMessage(""), 5000);
    } finally {
        setIsLoading(false);
    }
};

export const savePasswordOtp = async (otpValue, navigate, setIsLoading, setErrorMessage, setSuccessMessage,) => {
    setIsLoading(true);
    try {
        localStorage.setItem('otpCode', otpValue);

        setSuccessMessage("OTP saved");
        setTimeout(() => setSuccessMessage(""), 3000);
        setTimeout(() => navigate('/password'), 1500);
        
    } catch (error) {
        setErrorMessage("Failed to save OTP. Please try again.");
        // console.error("Failed to save OTP:", error);
        setTimeout(() => setErrorMessage(""), 5000);
    } finally {
        setIsLoading(false);
    }
};

export const changePassword = async (credentials) => {
    try {
        const { data } = await authApi.changePassword(credentials);
        // console.log(data);

        // localStorage.removeItem("sessionId");
        localStorage.removeItem("otpCode");
        localStorage.removeItem("recoveryEmail");
        
    } catch (error) {
        // console.error('Password reset attempt failed:', error);
        throw new Error("Password reset attempt failed");    
    }
}

export const initiateKyc = async (credentials) => {
    // console.log(credentials);
    try {
        const { data } = await userApi.updateKycDetails(credentials);
        // console.log(data);

        
    } catch (error) {
        // console.error('KYC initiation failed:', error);
        throw new Error("KYC initiation failed");    
    }
}

export const updatingKycDetails = async (credential, dispatch, toast) => {
    try {
        const { data } = await userApi.updateKycDetails(credential);
        // const { data } = await api.updateKycDetails(kyc_reference_id);

        // console.log(data);
        dispatch(setUser(data?.data?.user));
        // refreshUserDetails(dispatch);
        toast.success("Your KYC details has been submitted successfully for review.");

        
    } catch (error) {
        // console.error('KYC updating failed:', error);
        toast.error("KYC updating failed. Please try again.");
        // throw new Error("KYC updating failed");    
    }
}


export const updateUserProfile = async (credentials, userId, setLoading, setSuccessMessage, setErrorMessage, setIsEdited, dispatch) => {
    setLoading(true);
    // console.log(credentials);
    
    try {
        const { data } = await userApi.updateUserProfile(credentials, userId);
        // console.log(data);

        dispatch(setUser(data.data.user));
        
        setSuccessMessage("Profile updated successfully!");
        setTimeout(() => setSuccessMessage(""), 10000);
        setIsEdited(false);
    } catch (error) {
        let errorTxt;
        const responseErrors = error?.response?.data?.errors;
        if (responseErrors && Object.keys(responseErrors).length > 0) {
            const errorMessages = Object.values(responseErrors)
                .flat()
                .filter(Boolean); 

            errorTxt = errorMessages.length > 1 ? errorMessages[0] : errorMessages.join("<br/>");
            setErrorMessage(errorTxt || "Failed to update profile. Please try again.");
        }else{
            setErrorMessage("Failed to update profile. Please try again.");
        }
        setTimeout(() => setErrorMessage(""), 10000);
    } finally {
        setLoading(false);
    }
}

export const createTransactionPin = async (credentials, setLoading, setSuccessMessage, setIsEdited, dispatch) => {
    setLoading(true);
    try {
        const { data } = await api.updateTransactionPin(credentials);
        // console.log(data);

        setSuccessMessage("Your Pin has been updated successfully!");
        setIsEdited(false);
        setTimeout(() => setSuccessMessage(""), 10000);

        const storedUserDetails = JSON.parse(localStorage.getItem("userDetails"));

        if (storedUserDetails && !storedUserDetails.advanced_info.transfer_pin_set) {
            const updatedUserDetails = {
                ...storedUserDetails,
                advance_info: {
                    ...storedUserDetails.advance_info,
                    transfer_pin_set: true
                }
            };

            dispatch(setUser(updatedUserDetails));
            getAuthenticatedUser(dispatch);
        }
    } catch (error) {
        throw error;
    } finally {
        setLoading(false);
    }
}

export const googleAuth = async (credentials, dispatch, navigate, toast, setIsLoading) => {
    setIsLoading(true);
    try {
        const { data } = await authApi.googleAuth(credentials);
        // console.log(data);

        localStorage.setItem('token', data.data.auth_token.plainTextToken);
        localStorage.setItem('userDetails', JSON.stringify(data.data.user));
        localStorage.setItem('authData', JSON.stringify(data.data));
        if (credentials.flow === 'register') {
            localStorage.removeItem("account_type");
        }

        toast.success(`${credentials.flow === 'register' ? 'Registration' : 'Login'} successful!`);

        dispatch(setUser(data.data.user));
        
        getUserDetails(dispatch);
        
        setTimeout(() => navigate('/user/dashboard'), 3000);

        setTimeout(() => {
            dispatch(stopLoading());
        }, 5000);
        
    } catch (error) {
        const responseErrors = error?.response?.data?.errors;
        const fallbackMessage = error?.response?.data?.message || "Google authentication failed. Please try again.";
        
        if (responseErrors && Object.keys(responseErrors).length > 0) {
            const errorMessages = Object.values(responseErrors)
            .flat()
            .filter(Boolean); 

            toast.error(errorMessages.length > 1 
                ? errorMessages[0] 
                : errorMessages.join("<br/>")
            );
        } else {
            toast.error(fallbackMessage);
        }
        // console.error('Google authentication failed:', error);
    } finally {
        setIsLoading(false);
    }
}